module.exports = __webpack_public_path__ + "components/country-flag/static/jo-911f82fafa2773352ab8b1c09b508328.svg";